import { FC, PropsWithChildren } from 'react'
import s from './Navbar.module.css'

const NavbarRoot: FC<PropsWithChildren> = ({ children }) => {
  return <div className={s.root}>{children}</div>
}

export default NavbarRoot
